import * as React from 'react';
import { Component } from 'react';
import { Header } from '../Layout/Header';
import { Footer } from '../Layout/Footer';
import { LeftSide } from '../Layout/LeftSide';
import { RightSide } from '../Layout/RightSide';
import { ToastContainer } from 'react-toastify';
import CookieConsent from "react-cookie-consent";
import "react-table/react-table.css";
import IdleTimer, { IdleTimerProps } from 'react-idle-timer';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AdminService from '../services/AdminService';
import logo_temple from '../assets/images/logo_temple.png'
import { IUser } from '../Interface/IUser';
import { IMainMenu } from '../Interface/IMainMenu';
import { Link, match, NavLink, RouteComponentProps } from 'react-router-dom';
import tophandleimg from '../assets/img/handle.png';
import bottomhandleimg from '../assets/img/btm.png';
import { ModalComponent } from '../components/shared/ModalComponent';
import { getDateLabel, getDateTimeLabel, getFullDateTimeLabel } from '../Utils/AppFunc';
import { EventDetail } from '../components/EventDetail';
import { IDropdownValues } from '../Interface/IDropdownValues';
import history from "../history";
import { getFromDB, saveToDB } from "./../Utils/indexedDb";

interface Props extends RouteComponentProps<EventIDProps> {
    match: match<EventIDProps>;
}

interface EventIDProps {
    EventId: string
}

interface Props {
    children?: React.ReactNode;
    EventId: string
}

interface State {
    // TopBanner
    title: string,
    subTitle: string,
    contactNo: string,
    userDetail: IUser,
    // LeftSideBar
    menus: IMainMenu[],
    selectedMenu: string,
    lastActiveMenu: string,


    isLoggedIn: boolean,
    activeId: string,
    todayProgram: any,
    modalEvent: string,
    modalContent: string,
    today: Date,
    templeTiming1: string,
    templeTiming2: string,
    eventId: number,
    serviceBookingList: IDropdownValues[],
    isTimedOut: boolean,
    showTimeoutModal: boolean,
    isAdmin: boolean,
    isNavCollapsed: boolean,
}



export default class MainLayout extends Component<Props, State> {
    todayProgramModal: ModalComponent

    idleTimer: IdleTimer | null
    logoutTimer: any

    constructor(props: any) {
        super(props);
        this.idleTimer = null;
        this.logoutTimer = null;
        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this)
        this.state = {
            // TopBanner
            title: "",
            subTitle: "",
            contactNo: "",
            userDetail: null,
            // LeftSideBar
            menus: [],
            selectedMenu: "",
            lastActiveMenu: "",
            isLoggedIn: false,
            activeId: '0',
            todayProgram: null,
            modalEvent: "",
            modalContent: "",
            today: new Date(),
            templeTiming1: "",
            templeTiming2: "",
            eventId: 0,
            serviceBookingList: null,
            isTimedOut: false,
            showTimeoutModal: false,
            isAdmin: false,
            isNavCollapsed: true,
        };
    }

    componentDidMount() {
        require('../assets/styles/style.css');
        this.GetPageContent();
        this.GetLoggedInUserDetails();
    }

    handleNavCollapse() {
        this.setState({
            isNavCollapsed: !this.state.isNavCollapsed,
        })
    }

    handleOnAction(event) {
        // console.log('user did something', event)
        this.setState({ isTimedOut: false })
    }

    handleOnActive(event) {
        // console.log('user is active', event)
        // console.log('time remaining', this.idleTimer.getRemainingTime())
        this.setState({ isTimedOut: false })
    }

    handleOnIdle(event) {
        if (this.state.isLoggedIn) {
            this.togglePopup();
            this.logoutTimer = setTimeout(() => {
                this.handleLogout();
            }, 1000 * 60 * 5); // 5 minutes
        }
    }

    handleLogout = () => {
        localStorage.removeItem("user");
        AdminService.UserLogOut();
        history.push("/SignIn");
        window.location.reload();
    }

    GetPageContent = async () => {
        const cachedData = await getFromDB("HomeScreen","homePageContent");

        if (cachedData) {
           this.handleCachedData(cachedData);
        }
        var user = JSON.parse(localStorage.getItem("user"));

        var UserId = user == null ? -1 : user.id;

        var result = await AdminService.GetHomePageContent(UserId);
        var data2 = await AdminService.GetDropdownValues("ServiceBooking");

        if (data2 && data2.value) {
            this.setState({ serviceBookingList: data2.value })
        }
        if (result.value) {
            if (result.value["pageContent"].length > 0) {

                var topBanner = result.value["pageContent"].filter(m => (m.title).toLowerCase() == "topbanner");
                var bannerContent = topBanner.sort((a, b) => a.contentOrder - b.contentOrder);

                var pancahngam = result.value["pageContent"].filter(m => (m.title).toLowerCase() == "pancahngam");
                var pancahngamContent = pancahngam.sort((a, b) => a.contentOrder - b.contentOrder);

                this.setState({
                    title: bannerContent.length > 0 ? bannerContent[0].content : "", subTitle: bannerContent.length > 0 ? bannerContent[1].content : "",
                    contactNo: bannerContent.length > 0 ? bannerContent[2].content : ""
                })
            }

            if (result.value["mainMenu"].length > 0 && result.value["subMenu"].length > 0) {
                let Menu = result.value["mainMenu"];
                let SubMenu = result.value["subMenu"];

                for (var i = 0; i < Menu.length; i++) {
                    var menuList = SubMenu.filter(m => m.menuId == Menu[i].menuId);
                    Menu[i].subMenuList = menuList;
                }

                this.setState({ menus: Menu });
            }

            if (result.value["dailyEvents"].length > 0) {
                var content = result.value["dailyEvents"];
                this.setState({ todayProgram: content });
            }

            if (result.value["templeTimings"].length > 0) {
                var today = getDateLabel(String(this.state.today));
                var timing = result.value["templeTimings"].filter(m => getDateLabel(m.date) == today);

                if (timing && timing[0]) {
                    var time = timing[0].time ? timing[0].time.split(",") : null;

                    if (time) {
                        this.setState({ templeTiming1: time[0], templeTiming2: time[1] });
                    }

                }
            }
            await saveToDB("HomeScreen","homePageContent", result.value);
        }
    }

    handleCachedData = async (cachedData :any) => {
        if (cachedData["pageContent"].length > 0) {

            var topBanner = cachedData["pageContent"].filter(m => (m.title).toLowerCase() == "topbanner");
            var bannerContent = topBanner.sort((a, b) => a.contentOrder - b.contentOrder);

            var pancahngam = cachedData["pageContent"].filter(m => (m.title).toLowerCase() == "pancahngam");
            var pancahngamContent = pancahngam.sort((a, b) => a.contentOrder - b.contentOrder);

            this.setState({
                title: bannerContent.length > 0 ? bannerContent[0].content : "", subTitle: bannerContent.length > 0 ? bannerContent[1].content : "",
                contactNo: bannerContent.length > 0 ? bannerContent[2].content : ""
            })
        }

        if (cachedData["mainMenu"].length > 0 && cachedData["subMenu"].length > 0) {
            let Menu = cachedData["mainMenu"];
            let SubMenu = cachedData["subMenu"];
            for (var i = 0; i < Menu.length; i++) {
                var menuList = SubMenu.filter(m => m.menuId == Menu[i].menuId);
                Menu[i].subMenuList = menuList;
            }
            this.setState({ menus: Menu });

        }

        if (cachedData["dailyEvents"].length > 0) {
            var content = cachedData["dailyEvents"];
            this.setState({ todayProgram: content });
        }

        if (cachedData["templeTimings"].length > 0) {
            var today = getDateLabel(String(this.state.today));
            var timing = cachedData["templeTimings"].filter(m => getDateLabel(m.date) == today);

            if (timing && timing[0]) {
                var time = timing[0].time ? timing[0].time.split(",") : null;

                if (time) {
                    this.setState({ templeTiming1: time[0], templeTiming2: time[1] });
                }

            }
        }
    }

    GetLoggedInUserDetails = async () => {
        var result = JSON.parse(localStorage.getItem("user"));
        if (result && result.email) {
            this.setState({ userDetail: result, isLoggedIn: true });
            if (result.isAdmin) {
                this.setState({ isAdmin: true })
            }
        }
    }

    UserLogOut = async (e) => {
        e.preventDefault();
        localStorage.removeItem("user");
        AdminService.UserLogOut();
        history.push("/SignIn");
        window.location.reload();

    }

    expandSubMenus = (menuName) => {
        if (this.state.lastActiveMenu != menuName) {
            this.setState({ selectedMenu: menuName, lastActiveMenu: menuName });
        }
        else {
            this.setState({ selectedMenu: "", lastActiveMenu: "" });
        }
    }

    openTodayProgramModal = async (url: any, event: any, eventId: any) => {
        this.setState({ modalEvent: event, modalContent: url, eventId: eventId });
        this.todayProgramModal.show();
    }

    togglePopup = () => {
        this.setState(prevState => ({ showTimeoutModal: !prevState.showTimeoutModal }));
    }

    handleStayLoggedIn = () => {
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
            this.logoutTimer = null;
        }
        this.idleTimer.reset();
        this.togglePopup();
    }

    renderTimeoutModal = () => {

        return (
            <Modal isOpen={this.state.showTimeoutModal} toggle={this.togglePopup} keyboard={false} backdrop="static">
                <ModalBody>
                    Your session is about to expire in 5 minutes due to inactivity. You will be redirected to the login page.
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleStayLoggedIn}>Stay Logged In</Button>
                </ModalFooter>
            </Modal>
        );
    }

    public render() {
        const { title, subTitle, contactNo, userDetail, menus, selectedMenu, isLoggedIn, todayProgram,
            today, modalEvent, modalContent, templeTiming1, templeTiming2, serviceBookingList, isAdmin } = this.state
        return (
            <div style={{ overflow: "hidden" }}>

                {/* Idle timeout in milliseconds. = 1000 millsecond = 1 second */}
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    timeout={1000 * 60 * 10} // 10 minutes
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    stopOnIdle={true}
                    onAction={this.handleOnAction}
                    debounce={250}
                />

<div id="register_tab" style={{ height: "35px" }}>
                    <div className="container-fluid">
                        {/* <div className="row clearfix"> */}
                        {/* <div className="col-md-2 bar">
                                <i className="fa fa-bars showing-btn" aria-hidden="true" />
                            </div> */}
                        <div className="bar" style={{ float: "left" }} >
                            <p>{userDetail ? <a href={""}> {userDetail.firstName ? "Welcome   " + userDetail.firstName : ""}</a> : ""}</p>
                        </div>
                        <div className="contact">
                            <p>{userDetail ? <a href={""} onClick={(e) => this.UserLogOut(e)}>Log Out</a> : <a href={"/SignIn"}>Log In</a>} | <a href={"/UserRegistration"}>Registration</a> </p>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
                <div id="header">
                    <div className="container">
                        <div className="row clearfix">
                            <div className="col-md-12">
                                <ul>
                                    <li><img src={logo_temple} alt="logo" /></li>
                                    <li>
                                        <a href="/"><h3>Hindu Temple And Cultural Center of the Rockies</h3></a>
                                        <p> <i className="fa fa-map-marker"></i>{" 7201 s.potomac st., centennial, co 80112,"}{"  "}<i className="fa fa-phone">{" "}</i>{" 303-858-9927"}</p>
                                    </li>
                                    <li><img src={logo_temple} alt="logo" /></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="main_content">
                    <div className="container-fluid">
                        <div className="row clearfix percentrow102">

                            {/* Mobile only navbar collapsible  */}
                            <nav className="navbar navbar-expand-lg navbar-light bg-light rounded hideindesktop">
                                <button className="custom-toggler navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample09" aria-controls="navbarsExample09" aria-expanded={!this.state.isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={this.handleNavCollapse.bind(this)}>
                                    <span className="navbar-toggler-icon"></span>
                                </button>

                                <div className={`${this.state.isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarsExample09">
                                    {menus ? menus.map((mainMenu, index) =>
                                        <ul key={index}>
                                            <div className="hiding-btn" onClick={this.handleNavCollapse.bind(this)}><i className="fa fa-close"></i></div>
                                            <li key={mainMenu.menuName} className={(mainMenu.selector) + (isLoggedIn ? "login" : "noLogin") + " mainMenu show-btn"}  >
                                                {(mainMenu.haveChild ? <a className="menuUL" onClick={() => this.expandSubMenus(mainMenu.selector)} >{mainMenu.menuName}</a> : <Link to={mainMenu.pageLink}>{mainMenu.menuName}</Link>)}
                                                {(mainMenu.haveChild ?
                                                    <ul key={mainMenu.selector} className={this.state.selectedMenu == mainMenu.selector ? mainMenu.selector + selectedMenu : mainMenu.selector} >
                                                        {
                                                            mainMenu.subMenuList.map(subMenu => <li key={subMenu.subMenuName} className="subMenu">
                                                                <NavLink to={subMenu.pageLink} className="" activeStyle={{ color: "#fd9e39" }}>{subMenu.subMenuName}</NavLink ></li>)
                                                        }
                                                    </ul>
                                                    : "")}
                                            </li>
                                        </ul>
                                    )
                                        : null}

                                </div>
                            </nav>

                            <div className="col-md-2 left_tab">
                                <div className="menu">
                                    {menus ? menus.map((mainMenu, index) =>
                                        <ul key={index}>
                                            <div className="hiding-btn"><i className="fa fa-close"></i></div>
                                            <li key={mainMenu.menuName} className={(mainMenu.selector) + (isLoggedIn ? "login" : "noLogin") + " mainMenu show-btn"}  >
                                                {(mainMenu.haveChild ? <a className="menuUL" onClick={() => this.expandSubMenus(mainMenu.selector)} >{mainMenu.menuName}</a> : <Link to={mainMenu.pageLink}>{mainMenu.menuName}</Link>)}
                                                {(mainMenu.haveChild ?
                                                    <ul key={mainMenu.selector} className={this.state.selectedMenu == mainMenu.selector ? mainMenu.selector + selectedMenu : mainMenu.selector} >
                                                        {
                                                            mainMenu.subMenuList.map(subMenu => <li key={subMenu.subMenuName} className="subMenu">
                                                                <NavLink to={subMenu.pageLink} className="" activeStyle={{ color: "#fd9e39" }}>{subMenu.subMenuName}</NavLink ></li>)
                                                        }
                                                    </ul>
                                                    : "")}
                                            </li>
                                        </ul>
                                    )
                                        : null}

                                </div>
                                <div className="righ-scroll paper desk_view event-width">
                                    <div className="right-scrolltitle-only" >
                                        <img src={tophandleimg} />

                                        <div className="right-scrolltitle">
                                            <div className="tmpl-timing">Temple Open @ <br />{templeTiming1 ? templeTiming1 : ""} <br />{templeTiming2 ? templeTiming2 : ""}</div>

                                            <div className="tdy-prgm">Today's Programs</div>

                                            <div className="right-overflow">
                                                {todayProgram ? todayProgram.map((eventName, index) =>
                                                    <div className="yoga" key={index}>
                                                        <a onClick={() => this.openTodayProgramModal(eventName.detailsURL, eventName.eventName, eventName.eventId)}>  {eventName.eventName}</a>

                                                        <h5>{eventName.fromTime + ' - ' + eventName.toTime}</h5>

                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <img src={bottomhandleimg} />
                                </div>
                                {/*<div className="serv_booking" style={{ marginBottom: "25%" }}>
                                    <div id="tempServiceLebel">
                                        <select className="popover__wrapper">
                                            {serviceBookingList ? serviceBookingList.map(service =>
                                                <option key={service.value} value={service.value}>{service.text}</option>
                                            ) : null}
                                        </select>
                                        <div className="popover__select">
                                            <p className="popover__select-message"></p>
                                        </div>
                                    </div>
                                    <button className="book">Service Booking</button>
                                </div>*/}
                            </div>
                            <div id="inner_content" className="col-md-8 content_sec inner_con overflow-content ">
                                {this.props.children}
                            </div>

                            <div className="col-md-2 right_tab">
                                <RightSide key="righsideNav" />
                            </div>

                        </div>
                    </div>
                    {this.renderTimeoutModal()}
                    <ToastContainer />
                    <Footer />
                </div>

                <ModalComponent
                    ref={x => this.todayProgramModal = x}
                    buttons={<div>
                        <button type="button" className="btn bg-link" data-dismiss="modal" onClick={() => this.todayProgramModal.hide()}>Close</button>
                    </div>}
                    dialogClassName="mx-width-70"
                    title={modalEvent}>
                    <div className="col-md-12 material-modal-Bg">
                        <div className="row">
                            <div className="col-md-12 todayProgramModal">
                                {/* <iframe src={modalContent} style={{zoom: '0.60'}} frameBorder={0} width="99.6%" height="100%" /> */}
                                <EventDetail eventId={String(this.state.eventId)} />
                                {/* <iframe width="99.6%" height="100%"  style={{zoom: '0.60'}}  src="modalContent" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                    </iframe> */}
                            </div>
                        </div>
                    </div>
                </ModalComponent>
                <CookieConsent>This website uses cookies to enhance the user experience.</CookieConsent>
            </div>
        );
    }
}



